import React, {useContext} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormHelperText from "@material-ui/core/FormHelperText";
// Form related
import { Field } from 'formik';
import { DatePicker } from 'formik-material-ui-pickers';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import { UserContext } from "../../../Models/UserContext";

import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const useStyles = makeStyles(connectionFormStyle);

export default function AuthorisedSignatories(props) {
    const user = useContext(UserContext);
    const classes = useStyles();
    const {formField, customerName, declarationText, representativeHelperText} = props;

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <h4 className={classes.sectionHeader}>Authorised Signatories</h4>
                    {declarationText}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <Field
                                component={CustomInput}
                                labelText="Customer Name (print)"
                                name="customer_name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    readOnly: true,
                                    value: customerName
                                }}
                            />
                            <GridContainer>
                                <GridItem xs={12} sm={6}>
                                    <Field
                                        component={CustomInput}
                                        labelText="Customer Signature"
                                        name="customer_signature"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6}>
                                    <Field
                                        component={DatePicker}
                                        format="DD/MM/yyyy"
                                        name={formField.customer_signature_date.name}
                                        id={formField.customer_signature_date.name}
                                        label={formField.customer_signature_date.label}
                                        className={classes.itemSpacer + " " + classes.underline}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Field
                                component={CustomInput}
                                labelText={formField.billing_acct_no.label}
                                name={formField.billing_acct_no.name}
                                id={formField.billing_acct_no.name}
                                formControlProps={{
                                    fullWidth: true
                                }}
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <Field
                                component={CustomInput}
                                labelText="Vodafone Representative Name (print)"
                                name="representative_name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    readOnly: true,
                                    value: user.data.first_name + " " + user.data.last_name
                                }}
                                helperText={representativeHelperText}
                            />
                            <GridContainer>
                                <GridItem xs={12} sm={6}>
                                    <Field
                                        component={CustomInput}
                                        labelText="Vodafone Representative Signature"
                                        name={formField.representative_signature.name}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6}>
                                    <Field
                                        component={DatePicker}
                                        format="DD/MM/yyyy"
                                        name={formField.representative_signature_date.name}
                                        id={formField.representative_signature_date.name}
                                        label={formField.representative_signature_date.label}
                                        className={classes.itemSpacer + " " + classes.underline}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6}>
                                    <Field
                                        component={CustomInput}
                                        labelText="Dealer Code"
                                        name="dealer_code"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            readOnly: true,
                                            value: user.data.dealer_code
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </div>
    );
}